import { render, staticRenderFns } from "./BaseValidCheckbox.vue?vue&type=template&id=974deef6&"
import script from "./BaseValidCheckbox.vue?vue&type=script&lang=js&"
export * from "./BaseValidCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports